"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.summary = exports.icon = exports.accordionItem = void 0;

var _react = require("@emotion/react");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 1.75em;\n  width: 1.75em;\n  fill: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  box-shadow: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var accordionItem = (0, _react.css)(_templateObject());
exports.accordionItem = accordionItem;

var icon = function icon(_ref) {
  var colors = _ref.colors;
  return (0, _react.css)(_templateObject2(), colors.primary);
};

exports.icon = icon;

var summary = function summary(_ref2) {
  var colors = _ref2.colors;
  return (0, _react.css)(_templateObject3(), colors.title);
};

exports.summary = summary;